export default __webpack_public_path__ + "static/media/shoes_chelseaboots.2ad1255c.png";